export default "__VITE_ASSET__C0y5i68l__"